import getDocRef from './getDocRef'
import { deleteDoc, setDoc } from 'firebase/firestore/lite'

const deleteDataById = async (id, getCollection, hardDelete) =>
  hardDelete === true
    ? deleteDoc(getDocRef(id, getCollection(false)))
    : setDoc(getDocRef(id, getCollection(false)), { deletedAt: new Date() }, { merge: true })

export default deleteDataById
